// Feature name -> help article URL for the "Learn more" link in settings
// headers. Kept empty so no external documentation site is linked; add
// internal documentation URLs here when they exist.
const FEATURE_HELP_URLS = {};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
